import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import {
  urlResolverGetAgb,
  urlResolverGetPrivacySecurity,
  urlResolverGetPrivacySecurityCreditCheck,
} from '../../../url-handling'
import { LoginRegistrationInputCheckBox } from '../LoginRegistrationInputCheckBox/LoginRegistrationInputCheckBox'

export const LoginRegistrationRegistrationFormTosAcceptedCheckBox: FC = () => {
  const config = useGlobalConfigContext()
  const anchor1 = (text: ReactNode[]): JSX.Element => (
    <Link href={urlResolverGetAgb(config)}>{text}</Link>
  )
  const anchor2 = (text: ReactNode[]): JSX.Element => (
    <Link href={urlResolverGetPrivacySecurity(config)}>{text}</Link>
  )
  const anchor3 = (text: ReactNode[]): JSX.Element => (
    <Link href={urlResolverGetPrivacySecurityCreditCheck(config)}>{text}</Link>
  )

  return (
    <LoginRegistrationInputCheckBox
      data-qa-id="register-form-tosAccepted"
      field="tosAccepted"
    >
      <FormattedMessage
        id="registrationForm.label.check.toc.new.text"
        values={{
          anchor1,
          anchor2,
          anchor3,
        }}
      />
    </LoginRegistrationInputCheckBox>
  )
}
